<template>
  <div>
    <b-card-actions
      action-refresh
      :show-loading="fetching"
      @refresh="refreshProductData"
    >
      <e-table-nested-rows
        :fields="fieldsTaxParameterInconsistencies"
        :items="getProductGroupedByNcm"
        nested-list-property="items"
        empty-text="Nenhum NCM sem parâmetro fiscal encontrado"
        :fetching="fetching"
      >
        <template #detail-cell(ean)="{ item }">
          <FormulateInput
            type="label"
            :label="$t('NCM')"
            :value="item.ncm"
            :name="item.ncm"
          />
        </template>
        <template #nested-cell(ean)="{ itemNested }">
          {{ itemNested.ean }}
        </template>

        <template #detail-cell(productName)="{ item }">
          <FormulateInput
            type="label"
            :label="$t('Descrição')"
            :value="item.ncmDescription"
            :name="`description_${item.ncm}`"
          />
        </template>
        <template #nested-cell(productName)="{ itemNested }">
          <e-product-router-link
            :sku-id="itemNested.skuId"
            :product-id="itemNested.productId"
            :product-name="itemNested.productName"
            :ean="itemNested.ean"
          />
        </template>

        <template #detail-cell(storeWithStockCount)="{ item }">
          {{ `${$t('Total de produtos')}:` }} <b>{{ item.items && item.items.length }}</b>
        </template>
        <template #nested-cell(storeWithStockCount)="{ itemNested }">
          {{ `${$t('Lojas com estoque')}:` }} <b>{{ itemNested.storeIdentifications }}</b>
        </template>
      </e-table-nested-rows>

      <p>Observação: Selecione a linha para visualizar os produtos</p>
    </b-card-actions>
  </div>
</template>

<script>
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import EProductRouterLink from '@/views/components/EProductRouterLink.vue'
import ETableNestedRows from '@/views/components/tables/ETableNestedRows.vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    ETableNestedRows,
    BCardActions,
    EProductRouterLink,
  },

  data() {
    return {
      loaded: false,
      fetching: false,
    }
  },

  computed: {
    ...mapState('pages/invoice/taxClassifications/productWithoutTaxParameter', ['products']),
    ...mapGetters('pages/invoice/taxClassifications/productWithoutTaxParameter', [
      'getProductGroupedByNcm',
    ]),

    fieldsTaxParameterInconsistencies() {
      return [
        {
          label: this.$t('EAN'),
          key: 'ean',
          tdClass: 'text-center',
          thStyle: { minWidth: '170px' },
          detailTdClass: 'table-warning d-flex gap-3 align-items-center',
        },
        {
          label: this.$t('Produto'),
          key: 'productName',
          detailTdClass: 'table-warning',
        },
        {
          label: "",
          key: 'storeWithStockCount',
          thStyle: { minWidth: '250px' },
          detailTdClass: 'table-warning',
        },
      ]
    },
  },

  mounted() {
    this.getData()
  },

  methods: {
    ...mapActions('pages/invoice/taxClassifications/productWithoutTaxParameter', [
      'fetchProductsWithoutTaxParameter',
    ]),

    async getData() {
      this.$nextTick(async () => {
        try {
          this.fetching = true
          await this.fetchProductsWithoutTaxParameter()
        } catch (error) {
          this.showGenericError({ error })
        } finally {
          this.fetching = false
        }
      })
    },

    refreshProductData() {
      this.getData()
    },
  },
}
</script>
